export default {
  // 页面/Tab 标签
  供应商文件: "供應商文件",
  供应商帐号: "供應商帳號",

  // 供应商列表
  供应商编号: "供應商編號",
  供应商名称: "供應商名稱",
  代理商: "代理商",
  生产商: "生產商",
  邀请人: "邀請人",
  代注册: "代注冊",
  邮箱邀请: "郵箱邀請",
  注册列表: "注冊列表",
  注册来源: "注冊來源",
  联系人: "聯係人",
  联系电话: "聯係電話",
  邀请日期: "邀請日期",

  // 企业文件/物料文件
  企业文件: "企業文件",
  物料文件: "物料文件",
  通知供应商上传文件: "通知供應商上傳文件",
  添加物料: "添加物料",

  // 物料项相关
  物料编号: "物料編號",
  物料名称: "物料名稱",
  编辑物料: "編輯物料",
  删除物料: "刪除物料",
  确认是否删除此物料: "確認是否刪除此物料？",

  // 账号审核弹窗
  供应商账号审核: "供應商帳號審核",
  审核成功: "審核成功",

  // 文件审核弹窗
  审批意见: "審批意見",
  请选择审批意见: "請選擇審批意見",
  通过: "通過",
  驳回: "駁回",
  意见说明: "意見說明",
  请填写意见说明: "請填寫意見說明",
  请输入意见说明: "請輸入意見說明",
  文件审核: "文件審核",

  // 添加/编辑物料弹窗
  "抱歉，无法查询到该物料编号，请重新查询输入。":
    "抱歉，無法查詢到該物料編號，請重新查詢輸入。",
  修改物料: "修改物料",
  添加物料弹窗: "添加物料",
  根据物料编码搜索: "根據物料編碼搜索",
  请输入物料编码: "請輸入物料編碼",
  物料编码: "物料編碼",
  物料名称必填: "請輸入物料名稱",

  // 账号操作按钮
  禁用成功: "禁用成功",
  禁用账号: "禁用帳號",
  确定要禁用该账号吗: "確定要禁用該帳號嗎？",
  禁用: "禁用",
  解禁成功: "解禁成功",
  解禁账号: "解禁帳號",
  确定要解禁该账号吗: "確定要解禁該帳號嗎？",
  解禁: "解禁",
  审核按钮: "審核",

  // 表格列名
  序号: "序號",
  注册邮箱: "註冊郵箱",
  姓名: "姓名",
  所属部门: "所屬部門",
  电话号码: "電話號碼",
  注册状态: "註冊狀態",
  最近登录时间: "最近登錄時間",
  文件名称: "文件名稱",
  文件有效期至: "文件有效期至",
  文件状态: "文件狀態",
  最新上传时间: "最新上傳時間",
  上传用户: "上傳用戶",
  最新版本: "最新版本",
  上一版本: "上一版本",

  // AccessedTab 准入和价格申请
  准入申请: "準入申請",
  价格申请: "價格申請",
  准入申请列表: "準入申請列表",
  价格申请列表: "價格申請列表",
  申请准入: "申請準入",
  供应商地址: "供應商地址",
  经营有效期至: "經營有效期至",
  联系人电话: "聯繫人電話",
  联系人邮箱: "聯繫人郵箱",

  // 删除确认
  "确定要删除此价格申请吗？": "確定要刪除此價格申請嗎？",

  // 错误和成功消息
  "获取申请ID失败，无法编辑": "獲取申請ID失敗，無法編輯 ",
  "获取申请ID失败，无法查看": "獲取申請ID失敗，無法查看",
  "获取申请ID失败，无法申请变更": "獲取申請ID失敗，無法申請變更",
  "获取申请ID失败，无法重新提交": "獲取申請ID失敗，無法重新提交",
  "获取申请ID失败，无法删除": "獲取申請ID失敗，無法刪除",
  已获取申请详情: "已獲取申請詳情",
  获取申请详情失败: "獲取申請詳情失敗",
  "获取申请详情失败，请重试": "獲取申請詳情失敗，請重試",
  已获取供应商详情: "已獲取供應商詳情",
  获取供应商详情失败: "獲取供應商詳情失敗",
  "获取供应商详情失败，请重试": "獲取供應商詳情失敗，請重試",
  "申请已通过，请等待下一步": "申請已通過，請等待下一步",
  申请提交失败: "申請提交失敗",
  "申请提交失败，請重試": "申請提交失敗，請重試",
  "删除失败，请重试": "刪除失敗，請重試",

  // 准入申请弹框相关
  供应商准入申请表: "供應商準入申請表",
  单号: "單號",
  加载中: "加載中",
  下一步: "下一步",
  上一步: "上一步",
  缺少必要的数据无法打开评估表单: "缺少必要的數據，無法打開評估表單",
  获取评估详情失败: "獲取評估詳情失敗",
  "获取评估详情失败，请重试": "獲取評估詳情失敗，請重試",
  "获取单号失败，请重新打开": "獲取單號失敗，請重新打開",
  "无法获取用户信息，请重新登录": "無法獲取用戶信息，請重新登錄",
  请至少添加一条银行信息: "請至少添加一條銀行信息",
  请完整填写所有银行信息的必填字段: "請完整填寫所有銀行信息的必填字段",
  抱歉SAP没有这些标红的开户行行号: "抱歉！SAP沒有這些標紅的開戶行行號",
  无法进行下一步: "無法進行下一步",
  "检测开户行行号失败，请重试": "檢測開戶行行號失敗，請重試",
  请选择审核意见: "請選擇審核意見",
  审批通过成功: "審批通過成功",
  驳回成功: "駁回成功",
  "审批失败，请重试": "審批失敗，請重試",
  获取准入申请详情失败: "獲取準入申請詳情失敗",
  "获取准入申请详情失败，请重试": "獲取準入申請詳情失敗，請重試",
  "缺少流程单号，无法提交申请": "缺少流程單號，無法提交申請",
  "提交准入申请失败，请重试": "提交準入申請失敗，請重試",
  文件上传失败: "文件上傳失敗",
  成功批量上传: "成功批量上傳",
  个文件: "個文件",
  "文件信息记录失败，但文件已成功上传到OSS":
    "文件信息記錄失敗，但文件已成功上傳到OSS",
  "表单验证失败，请检查表单错误": "表單驗證失敗，請檢查表單錯誤",
  暂存: "暫存",
  提交: "提交",
  审批通过: "審批通過",

  // formConfig2.tsx 相关翻译
  生产物料: "生產物料",
  非生产物料: "非生產物料",
  "A类物料（战略物料）": "A類物料（戰略物料）",
  "B、C类物料+AF委外采购产品": "B、C類物料+AF委外採購產品",
  OEM客户专用物料: "OEM客戶專用物料",
  一般供应商: "一般供應商",
  重点供应商: "重點供應商",
  战略供应商: "戰略供應商",
  "C01 Dir.Matl-Plant 工厂-生产物料": "C01 Dir.Matl-Plant 工廠-生產物料",
  "C02 Indir.Matl-MRO 工厂-易耗品": "C02 Indir.Matl-MRO 工廠-易耗品",
  "C03 Indir.Matl-Other 工厂-固定资产/项目":
    "C03 Indir.Matl-Other 工廠-固定資產/項目",
  "C04 Dir.Matl-Other 研发-小试物料": "C04 Dir.Matl-Other 研發-小試物料",
  "C05 Dir.Matl-For E5 工厂-生产物料": "C05 Dir.Matl-For E5 工廠-生產物料",
  "C06 Idir.Matl-R&D 研发-固定资产/项目":
    "C06 Idir.Matl-R&D 研發-固定資產/項目",
  "C07 Dir.Matl-Scale-up 研发-中试物料": "C07 Dir.Matl-Scale-up 研發-中試物料",

  // formConfig.tsx 表单字段标签
  姓氏: "姓氏",
  名字: "名字",
  员工姓名: "員工姓名",
  员工编号: "員工編號",
  创建日期: "創建日期",
  部门: "部門",
  岗位: "崗位",
  邮箱: "郵箱",
  "供应商名称（中文）": "供應商名稱（中文）",
  "供应商名称（英文）": "供應商名稱（英文）",
  营业有效期: "營業有效期",
  "统一社会信用代码/商业登记号": "統一社會信用代碼/商業登記號",
  企业类型: "企業類型",
  生产商名称: "生產商名稱",
  国家: "國家",
  "省份/城市": "省份/城市",
  邮编: "郵編",
  "街道/门牌号": "街道/門牌號",
  语言: "語言",
  经营范围: "經營範圍",
  银行信息: "銀行信息",
  营业执照: "營業執照",
  收款授权信: "收款授權信",
  开户证明: "開戶證明",
  其他: "其他",

  // formConfig2.tsx 表单字段标签
  供应商编码: "供應商編碼",
  工厂: "工廠",
  物料类别: "物料類別",
  是否为GMP: "是否為GMP",
  采购类型: "採購類型",
  供应商等级: "供應商等級",
  采购小组: "採購小組",
  货币: "貨幣",
  付款方式: "付款方式",
  付款条款: "付款條款",
  国际贸易条款: "國際貿易條款",
  科目小组: "科目小組",
  科目编号: "科目編號",
  OA地址: "OA地址",
  PI发票方: "PI發票方",
  查看评估结果: "查看評估結果",

  // PriceApplicationModal 相关翻译
  供应商价格申请表: "供應商價格申請表",
  申请日期: "申請日期",
  工号: "工號",
  年度需求金额: "年度需求金額",
  价格变动范围: "價格變動範圍",
  是否为首次采购: "是否為首次採購",
  报价单: "報價單",
  询比议价结果: "詢比議價結果",
  价格明细: "價格明細",
  获取物料: "獲取物料",
  暂无数据: "暫無數據",
  请先选择工厂: "請先選擇工廠",
  请先选择供应商: "請先選擇供應商",

  // QuotationModal 相关翻译
  询比单号: "詢比單號",
  询比名称: "詢比名稱",
  截止时间: "截止時間",
  询比状态: "詢比狀態",
  创建人: "創建人",
  询比中: "詢比中",
  已完成: "已完成",
  确认选择: "確認選擇",
  加载失败请重试: "加載失敗，請重試",
  暂无报价单: "暫無報價單",
  共_条数据: "共 {total} 條數據",

  // formConfig.tsx 表单字段标签
  项目: "項目",
  预计交货天数: "預計交貨天數",
  "标准数量（SAP包装单位）": "標準數量（SAP包裝單位）",
  新价格: "新價格",
  "新价格（HKD）": "新價格（HKD）",
  价格单位: "價格單位",
  由: "由",
  "物料单位（订单）": "物料單位（訂單）",
  转换至: "轉換至",
  基本单位: "基本單位",
  阶梯数量价格: "階梯數量價格",
  新价格生效日期: "新價格生效日期",
  价格有效期至: "價格有效期至",
  物料等级: "物料等級",
  旧价格: "舊價格",
  "旧价格（HKD）": "舊價格（HKD）",
  价格变动比率: "價格變動比率",
  回传状态: "回傳狀態",
  操作: "操作",
  删除: "刪除",
  元: "元",
  港元: "港元",
  美元: "美元",
  个: "個",
  千克: "千克",
  米: "米",
  请输入物料编号: "請輸入物料編號",
  请选择日期: "請選擇日期",
  "New Price 新价格": "New Price 新價格",
  "Price Decrease 降价": "Price Decrease 降價",
  "Price Increase 加价": "Price Increase 加價",
  "E1 Bright Future": "E1 Bright Future",
  "E2 BF Chinese Medicine": "E2 BF Chinese Medicine",
  "E4 SumaUS": "E4 SumaUS",
  "E5 SumaHK": "E5 SumaHK",
  "A materia ls A类物料": "A materia ls A類物料",
  "B,C materials and new materials+AF OEM out products B,C类物料和新物料+AF委外采购产品":
    "B,C materials and new materials+AF OEM out products B,C類物料和新物料+AF委外採購產品",
  "Lab study, scale up materials 研发中小试和中试物料":
    "Lab study, scale up materials 研發中小試和中試物料",
  "Type A,B Material A类物料/B类物料": "Type A,B Material A類物料/B類物料",
  "Type C,D Material C,D类物料": "Type C,D Material C,D類物料",
  "RD scale up raw material(Equvalent to D material) 研发中试物料":
    "RD scale up raw material(Equvalent to D material) 研發中試物料",
  "All Material 所有物料": "All Material 所有物料",
  "Type A/B Material A类物料/B类物料": "Type A/B Material A類物料/B類物料",
  "Type C/D Material(inlcude scale up materials) C类物料/D类物料":
    "Type C/D Material(inlcude scale up materials) C類物料/D類物料",
  "A materials A类物料": "A materials A類物料",
  "RD scale up raw material 研发中试物料":
    "RD scale up raw material 研發中試物料",
  "Smaller than 300K 小于30万": "Smaller than 300K 小於30萬",
  "Equal or bigger than 300K 大于或等于30万":
    "Equal or bigger than 300K 大於或等於30萬",
  "Smaller than 500K 小于50万": "Smaller than 500K 小於50萬",
  "Equal or bigger than 500K 大于或等于50万":
    "Equal or bigger than 500K 大於或等於50萬",
  All: "All",
  "Smaller than 小于10%": "Smaller than 小於10%",
  "Equal or bigger than 10% 大于或等于10%":
    "Equal or bigger than 10% 大於或等於10%",
  "Smaller than 30% 小于30%": "Smaller than 30% 小於30%",
  "Equal or bigger than 30% 大于或等于30%":
    "Equal or bigger than 30% 大於或等於30%",
  是: "是",
  否: "否",

  // formConfig.tsx 占位符和按钮文本
  请选择申请类型: "請選擇申請類型",
  请先选择申请类型: "請先選擇申請類型",
  请选择年度需求金额: "請選擇年度需求金額",
  请选择价格变动范围: "請選擇價格變動範圍",
  请输入文本: "請輸入文本",
  请选择报价单: "請選擇報價單",
};
